module.exports = __webpack_public_path__ + "4c4891e985f5d9b8cc7c3347730c784b.svg";